"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ESchoolStatus = void 0;
var ESchoolStatus;
(function (ESchoolStatus) {
  /** Удалена или заблокирована */
  ESchoolStatus[ESchoolStatus["removed"] = -1] = "removed";
  /** Только создали */
  ESchoolStatus[ESchoolStatus["draft"] = 0] = "draft";
  /** Отклонена с модерации */
  ESchoolStatus[ESchoolStatus["verification_declined"] = 10] = "verification_declined";
  /** На модерации */
  ESchoolStatus[ESchoolStatus["under_verification"] = 30] = "under_verification";
  /** Промодерирована */
  ESchoolStatus[ESchoolStatus["verified"] = 50] = "verified";
  /** Опубликована и работает */
  ESchoolStatus[ESchoolStatus["published"] = 60] = "published";
  /** Опубликована и работает */
  ESchoolStatus[ESchoolStatus["working"] = 100] = "working";
})(ESchoolStatus = exports.ESchoolStatus || (exports.ESchoolStatus = {}));
